export const localeCode = { EN: "en", ES: "es", ET: "et" };
const common = {
  en: {
    nav: ["About", "Skills", "Projects", "Journal", "Contact"],
    role: "FULL-STACK DEVELOPER · ESTONIA",
    intro:
      "I build complete digital solutions, from responsive interfaces and backend APIs to databases, integrations and deployment.",
    work: "Explore my work",
    contact: "Get in touch",
    fullstack: "FULL-STACK",
    interface: "From interface to infrastructure.",
    selected: "SELECTED WORK",
    projects: "Projects built to work.",
    all: "View all projects",
    approach: "APPROACH",
    clear: "Clear thinking.",
    systems: "Useful systems.",
    simple: "Keep it simple.",
    latest: "LATEST PROJECT",
    coreTechnologies: "Core technologies",
    capabilities: "CAPABILITIES / TOOLKIT",
    skillsTitle: "Full-stack,",
    skillsEm: "end to end.",
    skillsIntro:
      "I connect every layer of a digital product, from the interface people use to the infrastructure that keeps it running.",
    certifications: "CERTIFICATIONS",
    continuous: "Continuous learning.",
    frontendCopy:
      "React, TypeScript, JavaScript, CSS, Sass, Redux and responsive interfaces.",
    backend: "Backend & APIs",
    backendCopy:
      "Node.js, Express, PHP, Python, Django, GraphQL and third-party integrations.",
    dataDelivery: "Data & delivery",
    dataDeliveryCopy:
      "MySQL, PostgreSQL, Docker, AWS and realtime product experiences.",
    close:
      "I turn ideas into polished, user-friendly products while keeping the technology dependable and the experience focused.",
    selectedWork: "Selected work",
    allProjects: "All projects",
    recommendations: "Recommendations",
    portfolio: "Portfolio",
    readRecommendations: "Read recommendations",
    recommendation: "Recommendation",
    readCase: "Read case study",
    visitProject: "Visit project",
    project: "PROJECT",
    imagePending: "Project screenshot pending",
    previewSoon: "Preview coming soon",
    seeMore: "See more",
    journalLabel: "DEVELOPMENT / NOTES",
    journalIntro:
      "Notes on the tools, indicators and software systems I build.",
    readArticle: "Read article",
    writtenBy: "Written by",
    viewTradingView: "View project on TradingView",
    backJournal: "Back to Journal",
    loading: "Loading…",
    notFound: "Page not found",
    notFoundCopy: "The page you requested could not be found.",
    backHome: "Back to home",
    contactLabel: "CONTACT / COLLABORATION",
    contactTitle: "Let's build something useful.",
    contactIntro:
      "Tell me about your product, technical challenge or idea. I will reply as soon as possible.",
    connect: "Connect",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    theme: "Toggle color theme",
    menu: "Open menu",
    closeMenu: "Close menu",
    projectSections: "Project sections",
    recommendationAuthors: "Recommendation authors",
    featuredRecommendation: "Featured recommendation",
  },
  es: {
    nav: ["Sobre mí", "Habilidades", "Proyectos", "Diario", "Contacto"],
    role: "DESARROLLADOR FULL-STACK · ESTONIA",
    intro:
      "Construyo soluciones digitales completas, desde interfaces responsive y APIs backend hasta bases de datos, integraciones y despliegue.",
    work: "Ver proyectos",
    contact: "Contactar",
    fullstack: "FULL-STACK",
    interface: "De la interfaz a la infraestructura.",
    selected: "PROYECTOS DESTACADOS",
    projects: "Proyectos creados para funcionar.",
    all: "Ver todos los proyectos",
    approach: "ENFOQUE",
    clear: "Ideas claras.",
    systems: "Sistemas útiles.",
    simple: "Mantenerlo simple.",
    latest: "PROYECTO MÁS RECIENTE",
    coreTechnologies: "Tecnologías principales",
    capabilities: "CAPACIDADES / HERRAMIENTAS",
    skillsTitle: "Full-stack,",
    skillsEm: "de principio a fin.",
    skillsIntro:
      "Conecto cada capa de un producto digital, desde la interfaz que usan las personas hasta la infraestructura que lo mantiene en funcionamiento.",
    certifications: "CERTIFICACIONES",
    continuous: "Aprendizaje continuo.",
    frontendCopy:
      "React, TypeScript, JavaScript, CSS, Sass, Redux e interfaces responsive.",
    backend: "Backend y APIs",
    backendCopy:
      "Node.js, Express, PHP, Python, Django, GraphQL e integraciones con terceros.",
    dataDelivery: "Datos y entrega",
    dataDeliveryCopy:
      "MySQL, PostgreSQL, Docker, AWS y experiencias de producto en tiempo real.",
    close:
      "Convierto ideas en productos pulidos y fáciles de usar, con tecnología fiable y una experiencia centrada.",
    selectedWork: "Trabajo destacado",
    allProjects: "Todos los proyectos",
    recommendations: "Recomendaciones",
    portfolio: "Proyectos",
    readRecommendations: "Leer recomendaciones",
    recommendation: "Recomendación",
    readCase: "Leer caso de estudio",
    visitProject: "Visitar proyecto",
    project: "PROYECTO",
    imagePending: "Captura del proyecto pendiente",
    previewSoon: "Vista previa próximamente",
    seeMore: "Ver más",
    journalLabel: "DESARROLLO / NOTAS",
    journalIntro:
      "Notas sobre las herramientas, indicadores y sistemas de software que construyo.",
    readArticle: "Leer artículo",
    writtenBy: "Escrito por",
    viewTradingView: "Ver proyecto en TradingView",
    backJournal: "Volver al diario",
    loading: "Cargando…",
    notFound: "Página no encontrada",
    notFoundCopy: "No se encontró la página solicitada.",
    backHome: "Volver al inicio",
    contactLabel: "CONTACTO / COLABORACIÓN",
    contactTitle: "Construyamos algo útil",
    contactIntro:
      "Cuéntame sobre tu producto, reto técnico o idea. Responderé lo antes posible.",
    connect: "Conectar",
    name: "Nombre",
    email: "Correo electrónico",
    subject: "Asunto",
    message: "Mensaje",
    send: "Enviar mensaje",
    theme: "Cambiar tema de color",
    menu: "Abrir menú",
    closeMenu: "Cerrar menú",
    projectSections: "Secciones de proyectos",
    recommendationAuthors: "Autores de las recomendaciones",
    featuredRecommendation: "Recomendación destacada",
  },
  et: {
    nav: ["Minust", "Oskused", "Projektid", "Päevik", "Kontakt"],
    role: "FULL-STACK ARENDAJA · EESTI",
    intro:
      "Loon terviklikke digilahendusi alates kohanduvatest kasutajaliidestest ja backend API-dest kuni andmebaaside, integratsioonide ning juurutamiseni.",
    work: "Vaata projekte",
    contact: "Võta ühendust",
    fullstack: "FULL-STACK",
    interface: "Kasutajaliidesest infrastruktuurini.",
    selected: "VALITUD TÖÖD",
    projects: "Projektid, mis on loodud toimima.",
    all: "Vaata kõiki projekte",
    approach: "LÄHENEMINE",
    clear: "Selge mõtlemine.",
    systems: "Kasulikud süsteemid.",
    simple: "Hoia lihtsana.",
    latest: "UUSIM PROJEKT",
    coreTechnologies: "Põhitehnoloogiad",
    capabilities: "VÕIMEKUS / TÖÖRIISTAD",
    skillsTitle: "Full-stack,",
    skillsEm: "algusest lõpuni.",
    skillsIntro:
      "Ühendan digitoote iga kihi, alates inimeste kasutatavast liidesest kuni seda töös hoidva infrastruktuurini.",
    certifications: "SERTIFIKAADID",
    continuous: "Pidev õppimine.",
    frontendCopy:
      "React, TypeScript, JavaScript, CSS, Sass, Redux ja kohanduvad kasutajaliidesed.",
    backend: "Backend ja API-d",
    backendCopy:
      "Node.js, Express, PHP, Python, Django, GraphQL ja kolmandate osapoolte integratsioonid.",
    dataDelivery: "Andmed ja tarne",
    dataDeliveryCopy:
      "MySQL, PostgreSQL, Docker, AWS ja reaalaja tootekogemused.",
    close:
      "Muudan ideed viimistletud ja kasutajasõbralikeks toodeteks, hoides tehnoloogia töökindla ning kogemuse fookuses.",
    selectedWork: "Valitud tööd",
    allProjects: "Kõik projektid",
    recommendations: "Soovitused",
    portfolio: "Projektid",
    readRecommendations: "Loe soovitusi",
    recommendation: "Soovitus",
    readCase: "Loe juhtumiuuringut",
    visitProject: "Vaata projekti",
    project: "PROJEKT",
    imagePending: "Projekti kuvatõmmis on ootel",
    previewSoon: "Eelvaade on tulekul",
    seeMore: "Vaata lähemalt",
    journalLabel: "ARENDUS / MÄRKMED",
    journalIntro:
      "Märkmed tööriistade, indikaatorite ja tarkvarasüsteemide kohta, mida loon.",
    readArticle: "Loe artiklit",
    writtenBy: "Kirjutas",
    viewTradingView: "Vaata projekti TradingView's",
    backJournal: "Tagasi päevikusse",
    loading: "Laadimine…",
    notFound: "Lehte ei leitud",
    notFoundCopy: "Soovitud lehte ei leitud.",
    backHome: "Tagasi avalehele",
    contactLabel: "KONTAKT / KOOSTÖÖ",
    contactTitle: "Loome midagi kasulikku.",
    contactIntro:
      "Räägi mulle oma tootest, tehnilisest väljakutsest või ideest. Vastan esimesel võimalusel.",
    connect: "Võta ühendust",
    name: "Nimi",
    email: "E-post",
    subject: "Teema",
    message: "Sõnum",
    send: "Saada sõnum",
    theme: "Vaheta värviteemat",
    menu: "Ava menüü",
    closeMenu: "Sulge menüü",
    projectSections: "Projektide jaotised",
    recommendationAuthors: "Soovituste autorid",
    featuredRecommendation: "Esiletõstetud soovitus",
  },
};
export const getCopy = (locale) => common[localeCode[locale] || "en"];
export function translateKey(locale, key) {
  const code = localeCode[locale] || "en";
  const value = common[code]?.[key];
  if (value === undefined) {
    if (process.env.NODE_ENV !== "production")
      console.warn(`[i18n] Missing ${code}.${key}; using en.${key}`);
    return common.en[key] ?? key;
  }
  return value;
}
export const themeNames = {
  EN: { light: "Light", dark: "Dark" },
  ES: { light: "Claro", dark: "Oscuro" },
  ET: { light: "Hele", dark: "Tume" },
};
